export const getInterventionIdByExecutionId = (interventionZones, executionId) => interventionZones
  .flatMap(iz => iz.interventions)
  .find(i => i.executions
    .some(e => e.id === executionId));